<template>
    <div>
        <string-renderer v-if="(field.field_type === 'String' || field.field_type === 'URL') && fieldValue"
                         :field="field" :document="document"></string-renderer>

        <div v-else-if="field.field_type === 'Text' && fieldValue" class="rich-text mb-3">
            <div v-html="fieldValue"></div>
        </div>

        <select-view v-else-if="field.field_type === 'Single Select'" :document="document"
                     :field="field"></select-view>

        <date-renderer v-else-if="field.field_type === 'Date' && fieldValue"
                       :document="document" :field="field"></date-renderer>

        <div v-else-if="field.field_type === 'Collaborator' && fieldValue">
            <span class="badge text-bg-light">{{fieldValue.name}}</span>
        </div>

        <linked-object-renderer v-else-if="field.field_type === 'Link to Object'"
                                :document="document" :field="field" ></linked-object-renderer>

        <checkbox-view v-else-if="field.field_type === 'Boolean'" :document="document"
                       :field-name="field.index" :editable="true" :key="field.id + 'view'"
                       :table="table" class="my-2"></checkbox-view>

        <attachment-viewer v-else-if="field.field_type === 'Attachment'" :attachments="fieldValue"
                           :document="document" :field="field" :table="table" :image-size="50"></attachment-viewer>

        <number-renderer v-else-if="isNumeric && fieldValue" :document="document" :field="field" class="mb-3"></number-renderer>

        <image-renderer v-else-if="field.field_type === 'Image' && fieldValue" :component="imageComponent"></image-renderer>
    </div>
</template>

<script>
    import SelectView from "../../components/SelectView.vue";
    import DateRenderer from "../../components/DateRenderer.vue";
    import StringRenderer from "../../components/StringRenderer.vue";
    import NumberRenderer from "./NumberRenderer.vue";
    import FieldUtil from "../../utils/FieldUtil";
    import AttachmentViewer from "../controls/AttachmentViewer.vue";
    import CheckboxView from "../../components/CheckboxView.vue";
    import LinkedObjectRenderer from "./LinkedObjectRenderer.vue";
    import PageFactory from "../../utils/PageFactory";
    import ImageRenderer from "./ImageRenderer.vue";

    export default {
        name: 'FieldCellRenderer',
        components: {
            ImageRenderer,
            LinkedObjectRenderer,
            CheckboxView,
            AttachmentViewer,
            NumberRenderer,
            StringRenderer,
            DateRenderer,
            SelectView
        },
        props: ['field', 'document', 'table'],
        computed: {
            fieldValue() {
                return this.document[this.field.index]
            },
            isNumeric() {
                return new FieldUtil(this.field).isNumeric()
            },
            imageComponent() {
                let imageObject = this.fieldValue
                let pageFactory = new PageFactory()
                return pageFactory.createImageComponent(imageObject)
            }
        },
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
